import React, { useState, useEffect } from "react";
import { compose } from "recompose";
import { Table, Card, Row, Col, Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import {
  TableContainer,
  Pagination,
  TableDataFetch,
  AddNewButton,
  withTable,
  TableSearch,
  BulkDeleteButton,
  EditDeleteButtons,
  ViewingRecords,
} from "components/common/Tables/index";
import Page from "../../components/common/Page";
import PendingButton from "components/common/PendingButton";
import { formatDateTime } from "services/util";
import { Trans } from "react-i18next";
import { NotificationManager } from "react-notifications";

const StatCard = ({ label, value, onClick }) => {
  return (
    <Card body className="px-3 py-2 mb-2">
      <div className="d-flex flex-column align-items-center">
        <div
          style={{ lineHeight: "1.5rem", fontSize: ".875rem" }}
          className="font-weight-semibold text-nowrap"
        >
          <Trans>{label}</Trans>
        </div>
      </div>
    </Card>
  );
};

export const GroupList = ({
  selected,
  match,
  url = "authorization/group",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  filters,
  limit,
  offset,
  setOffset,
  setFilters,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
  client,
  pending
}) => {
  const [stats, setStats] = useState();

  useEffect(() => {
    (async () => {
      const stats = await client.get("authorization/group").get("data");
      setStats(stats);
    })();
  }, []);

  function onFilter(ids) {
    setFilters({
      ...filters,
      id__in: ids.join(","),
    });
  }
  const [isOpen, setIsOpen] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);

  const toggle = () => setIsOpen(!isOpen);

  const onDelete = (id) => {
    setSelectedGroupId(id);
    toggle(); 
  };

  const onConfirm = async () => {
    try {
      await client.delete(`/authorization/group/${selectedGroupId}`);
      NotificationManager.success('Group deleted successfully!');
      onDeleted(); 
    } catch (error) {
      console.error('Error deleting group:', error);
      NotificationManager.error('An error occurred while deleting the group.');
    } finally {
      toggle(); 
    }
  };

  return (
    <Page title="Permission Groups" className="inv-table">
      <TableContainer>
        <Table size="sm">
          <thead>
            <tr>
              <th className="text-left" sortBy="id">ID</th>
              <th className="text-left" sortBy="name">Group Name</th>
              <th className="text-left" sortBy="description">Role Description</th>
            </tr>
          </thead>
          <tbody>
            {data.results.map((i) => (
              <tr key={i.id}>
                <td className="text-left">{i.id}</td>
                <td className="text-left">{i.name}</td>
                <td className="text-left">Can be Assigned</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>

      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <Trans>
            Are you sure you want to delete this group?
          </Trans>
        </ModalBody>
        <ModalFooter>
          <PendingButton color="primary" pending={pending} onClick={onConfirm}>
            Confirm
          </PendingButton>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <TableDataFetch
        ordering={ordering}
        refreshToken={refreshToken}
        search={search}
        limit={limit}
        filters={filters}
        url={url}
        offset={offset}
        onDataFetched={setData}
      />
      <ViewingRecords
        offset={offset}
        limit={limit}
        count={data.count}
        className="float-left"
      />
      <div className="float-right">
        <Pagination
          size="sm"
          count={data.count}
          limit={limit}
          offset={offset}
          onOffsetChanged={setOffset}
        />
      </div>
    </Page>
  );
};

const enhance = compose(withTable({ limit: 100 }));

export default enhance(GroupList);
